// ============================================================================
// FILE: src/modules/invoice/components/InvoiceLineItemTable.jsx
// CREATED: 2025-12-03
// PURPOSE: Display extracted invoice line items (materials / goods).
// COMMENTS:
// - Used in both InvoiceUploadPage and InvoiceDetailPage
// - Pure display table (no editing yet)
// ============================================================================

import React from "react";

const InvoiceLineItemTable = ({ items }) => {
  if (!items || items.length === 0) {
    return <p>No line items found.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse bg-white shadow rounded-lg">
        <thead>
          <tr className="bg-gray-100 border-b">
            <th className="p-3 text-left">Description</th>
            <th className="p-3 text-left">Qty</th>
            <th className="p-3 text-left">Unit Price</th>
            <th className="p-3 text-left">Line Total</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item, idx) => (
            <tr key={idx} className="border-b hover:bg-gray-50">

              <td className="p-3">
                {item.description || "-"}
              </td>

              <td className="p-3">
                {item.qty !== undefined && item.qty !== null ? item.qty : "-"}
              </td>

              <td className="p-3">
                {item.unit_price !== undefined && item.unit_price !== null
                  ? item.unit_price
                  : "-"}
              </td>

              <td className="p-3">
                {item.line_total !== undefined && item.line_total !== null
                  ? item.line_total
                  : "-"}
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceLineItemTable;
